var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (i18n) {
buf.push("<div id=\"play-audio-popup\" class=\"block-xl\"><div class=\"content-fill\"><div class=\"content-ver text-center\"><div class=\"block-v-xl block-h-lg\"><h1>" + (jade.escape((jade_interp = i18n("audio-popup.title")) == null ? '' : jade_interp)) + "</h1><p class=\"text-md\">" + (jade.escape((jade_interp = i18n("audio-popup.description")) == null ? '' : jade_interp)) + "</p></div><div class=\"btn btn-solid btn-block btn-yes text-xl\">" + (jade.escape((jade_interp = i18n("audio-popup.allow")) == null ? '' : jade_interp)) + "</div></div><div class=\"btn btn-block btn-no btn-sm\">" + (jade.escape((jade_interp = i18n("audio-popup.cancel")) == null ? '' : jade_interp)) + "</div></div></div>");}.call(this,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}